import React from 'react';
import PropTypes from 'prop-types';

const DeleteIcon = ({ color = '#C70000', width = 7, height = 14 }) => (
    <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="Delete">
<path id="Rectangle 980" d="M15.85 4.14999L15.2922 13.1726C15.1497 15.4778 15.0785 16.6304 14.5007 17.4591C14.215 17.8688 13.8472 18.2146 13.4206 18.4744C12.5579 19 11.4031 19 9.09347 19C6.7808 19 5.62447 19 4.76115 18.4734C4.33432 18.2131 3.96639 17.8667 3.68081 17.4564C3.10319 16.6263 3.03351 15.4721 2.89415 13.1636L2.35 4.14999" stroke={color} stroke-linecap="round"/>
<path id="Vector" d="M17.2 4.14999H1" stroke={color} stroke-linecap="round"/>
<path id="Vector_2" d="M12.7501 4.15L12.1357 2.88255C11.7276 2.04063 11.5235 1.61967 11.1715 1.35713C11.0935 1.29889 11.0108 1.24709 10.9243 1.20223C10.5345 1 10.0667 1 9.13107 1C8.17194 1 7.69238 1 7.29611 1.21071C7.20828 1.25741 7.12448 1.31131 7.04556 1.37185C6.68947 1.64503 6.49056 2.0814 6.09274 2.95413L5.54763 4.15" stroke={color} stroke-linecap="round"/>
<path id="Line 5" d="M6.85 14.05L6.85 8.64999" stroke={color} stroke-linecap="round"/>
<path id="Line 6" d="M11.35 14.05L11.35 8.64999" stroke={color} stroke-linecap="round"/>
</g>
</svg>

);

DeleteIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};

export default DeleteIcon; 